import {
  DrawerType,
  DrawerInfo,
  INITIAL_DRAWER_INFO,
} from "components/EditorHome/Constants";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";

import { $Button, $Drawer, $Tooltip } from "us.common/components";
import { RootState } from "us.helper/types";
import * as Actions from "actions";
import { FileTextOutlined, SettingOutlined } from "us.icons";
import { GlobalRuleSetup, Settings } from "components";

/**
 * @description - USC Home Settings components to change settings and view rules
 * @link Design Document -
 * @author Roshan Maddumage <roshanma@unicorn-solutions.com>
 * @since 06/12/2024
 */
const HeaderSettings: React.FC<PropsFromRedux> = (props) => {
  const { getAllTemplateRules, getSettings } = props;
  const { t } = useTranslation();
  const [drawerInfo, setDrawerInfo] = useState<DrawerInfo>(INITIAL_DRAWER_INFO);

  /**
   * @description - Update drawer info state according to the drawer type
   */
  const updateDrawerInfo = (drawerType: string) => {
    if (drawerType == DrawerType.GLOBAL_RULES) {
      getAllTemplateRules && getAllTemplateRules({});
    } else {
      getSettings && getSettings(["all"]);
    }

    setDrawerInfo({
      title:
        drawerType == DrawerType.GLOBAL_RULES
          ? t("US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.TEMPLATE_RULES")
          : t("US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.SETTINGS"),
      visibility: true,
      type: drawerType,
    });
  };

  return (
    <>
      <div className="us-header-actions">
        <$Tooltip
          placement="bottom"
          title={t("US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.TEMPLATE_RULES")}
        >
          <div className="icon-header-btn home-btn">
            <$Button
              icon={<FileTextOutlined />}
              type="link"
              size="large"
              onClick={() => updateDrawerInfo(DrawerType.GLOBAL_RULES)}
            />
          </div>
        </$Tooltip>
        <$Tooltip
          placement="bottom"
          title={t("US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.SECTION_SETTINGS")}
        >
          <div className="icon-header-btn home-btn">
            <$Button
              icon={<SettingOutlined />}
              type="link"
              size="large"
              onClick={() => updateDrawerInfo(DrawerType.SETTINGS)}
            />
          </div>
        </$Tooltip>
      </div>
      <$Drawer
        title={drawerInfo.title}
        placement={"right"}
        width={"700px"}
        onClose={() => setDrawerInfo({ ...drawerInfo, visibility: false })}
        open={drawerInfo.visibility}
        destroyOnClose={true}
        className={
          drawerInfo.type == DrawerType.GLOBAL_RULES
            ? "check-template-rule-drawer"
            : "usc-settings-drawer"
        }
      >
        {drawerInfo.type == DrawerType.GLOBAL_RULES && <GlobalRuleSetup />}
        {drawerInfo.type == DrawerType.SETTINGS && (
          <Settings
            onClose={() => setDrawerInfo({ ...drawerInfo, visibility: false })}
          />
        )}
      </$Drawer>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {};
};

const { templateRules, settings } = Actions.editorHome;

const mapDispatchToProps = {
  getAllTemplateRules: templateRules.get,
  getSettings: settings.get,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(HeaderSettings);
